import { Skeleton, Card, Row, Col } from "antd";

const LoadingSkeleton = () => (
    <Row gutter={[16, 16]}>
        {[...Array(6)].map((_, i) => (
            <Col span={8} key={i}>
                <Card>
                    <Skeleton.Image active style={{ width: "100%", height: 120 }} />
                    <Skeleton active paragraph={{ rows: 3 }} />
                </Card>
            </Col>
        ))}
    </Row>
);

export default LoadingSkeleton;
